import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatTableDataSource, MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SuggestedAmount } from '@uw/core/models/suggested-amount.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'uw-suggested-amount-list',
    templateUrl: './suggested-amount-list.component.html',
    styleUrls: ['./suggested-amount-list.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CurrencyPipe, TranslateModule]
})
export class SuggestedAmountListComponent {
  private _dataSource!: MatTableDataSource<SuggestedAmount>;

  readonly currentLanguage = this._translateService.currentLang;

  readonly displayedColumns: string[] = [
    'lowerRangeAmount',
    'upperRangeAmount',
    'languageCode',
    'suggestedAmounts',
    'actions',
  ];

  @Input('suggestedAmounts') set suggestedAmounts(value: SuggestedAmount[]) {
    this._dataSource = new MatTableDataSource(value);
  }

  get dataSource() {
    return this._dataSource;
  }

  @Output() edit: EventEmitter<SuggestedAmount> = new EventEmitter();

  @Output() delete: EventEmitter<SuggestedAmount> = new EventEmitter();

  constructor(private readonly _translateService: TranslateService) {}

  public onEditKeydown(event: any, suggestedAmount: SuggestedAmount): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.edit.emit(suggestedAmount);
    }
  }

  public onRemoveKeydown(event: any, suggestedAmount: SuggestedAmount): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.delete.emit(suggestedAmount);
    }
  }
}

@NgModule({
    exports: [
        SuggestedAmountListComponent
    ],
    imports: [
        CommonModule,
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        SuggestedAmountListComponent
    ]
})
export class SuggestedAmountListModule { }
